var _defs, _path, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "phoneGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgba(150, 100, 255, 1)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgba(255, 100, 200, 1)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "phoneGlow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 46C54 47.3261 53.4732 48.5979 52.5355 49.5355C51.5979 50.4732 50.3261 51 49 51H43C41.6739 51 40.4021 50.4732 39.4645 49.5355C38.5268 48.5979 38 47.3261 38 46V40C38 38.6739 38.5268 37.4021 39.4645 36.4645C40.4021 35.5268 41.6739 35 43 35H48C49.3261 35 50.5979 34.4732 51.5355 33.5355C52.4732 32.5979 53 31.3261 53 30V14C53 12.6739 52.4732 11.4021 51.5355 10.4645C50.5979 9.52678 49.3261 9 48 9H16C14.6739 9 13.4021 9.52678 12.4645 10.4645C11.5268 11.4021 11 12.6739 11 14V30C11 31.3261 11.5268 32.5979 12.4645 33.5355C13.4021 34.4732 14.6739 35 16 35H21C22.3261 35 23.5979 35.5268 24.5355 36.4645C25.4732 37.4021 26 38.6739 26 40V46C26 47.3261 25.4732 48.5979 24.5355 49.5355C23.5979 50.4732 22.3261 51 21 51H15C13.6739 51 12.4021 50.4732 11.4645 49.5355C10.5268 48.5979 10 47.3261 10 46V14C10 11.3478 11.0536 8.80429 12.9289 6.92893C14.8043 5.05357 17.3478 4 20 4H44C46.6522 4 49.1957 5.05357 51.0711 6.92893C52.9464 8.80429 54 11.3478 54 14V46Z",
    stroke: "url(#phoneGrad)",
    strokeWidth: 2.5,
    filter: "url(#phoneGlow)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 16,
    r: 2,
    fill: "url(#phoneGrad)",
    opacity: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 16,
    r: 2,
    fill: "url(#phoneGrad)",
    opacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a78a86481bf5e2ee8b42ce43d64ad794.svg";
export { ForwardRef as ReactComponent };